import { useEffect, useState } from "react";
import { useAvtovazRequisites } from "./useAvtovazRequisites";

interface useGetItemRiquisiteIProps {
  id: string;
}
export const useGetItemRequisites = ({ id }: useGetItemRiquisiteIProps) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { getAvtovazRequisiteBuId } = useAvtovazRequisites();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await getAvtovazRequisiteBuId(id);
      if (res.status >= 400) {
        throw new Error(`${res.status}`);
      }
      setData(res.data);
    } catch (error) {
      setError("Ошибка получения реквизита");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  return { isLoading, error, data };
};
